import React, { useState, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, btnP, inpS } from "../../constants/styles";
import Fld from "../common/Fld";
import ReceiptView from "./ReceiptView";
import TxnHistory from "./TxnHistory";

function TenantPayHistoryPage() {
  const { t, h, pays, setPays, tens, props, selTid, go, flash, showConfirm } = useContext(Ctx);
  const te = tens.find(x => x.id === selTid);
  const tp = pays.filter(x => x.tid === selTid);
  const [receiptPay, setReceiptPay] = useState(null);
  const teProp = props?.find(x => x.id === te?.pid);

  const deleteHstPay = (payId) => {
    showConfirm(t.deletePayConfirm, () => {
      setPays(pays.filter(x => x.id !== payId));
      api.deletePayment(payId);
      flash(t.deleted);
    });
  };

  if (!te) return <div className="no-print" style={{ paddingTop: 16 }}><button onClick={() => go("tens")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back}</button><p style={{ color: h.tx }}>{t.tenNotFound}</p></div>;
  if (receiptPay) return <div style={{ paddingTop: 16 }}><ReceiptView pay={receiptPay} prop={teProp} tenant={te} onBack={() => setReceiptPay(null)} /></div>;

  const handleDownload = () => {
    let text = `PAYMENT HISTORY\nRajieev House Rental\n${"-".repeat(40)}\nTenant: ${te.name}\nPhone: ${te.ph}\nDate Generated: ${new Date().toLocaleDateString()}\n\n`;
    text += `MONTH | TOTAL | STATUS | RECORDED ON | METHOD\n${"-".repeat(60)}\n`;
    tp.forEach(p => {
      const tot = p.amt + (p.com || 0);
      text += `${p.mo} | ₹${tot} | ${p.st.toUpperCase()} | ${p.dt || "N/A"} | ${(p.mth || "N/A").toUpperCase()}\n`;
      if (p.txns && p.txns.length > 0) {
        text += `  -> Transactions:\n`;
        p.txns.forEach(tx => {
          text += `     ${tx.dt} | ₹${tx.amt} | ${(tx.mth || "").toUpperCase()} | ${tx.type} | ${tx.status.toUpperCase()}\n`;
        });
      }
    });
    text += `\n${"-".repeat(40)}\nEnd of Report`;

    const blob = new Blob([text], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `Payment_History_${te.name.replace(/\s/g, "_")}.txt`;
    a.click();
    URL.revokeObjectURL(url);
    flash(t.reportDl);
  };

  return <div>
    {/* APP UI (HIDDEN DURING PRINT) */}
    <div className="no-print" style={{ paddingTop: 16 }}>
      <button onClick={() => go("tens")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", fontSize: 13, marginBottom: 8 }}>&larr; {t.back} to Tenants</button>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ width: 48, height: 48, borderRadius: 24, background: h.ac, display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: 18, fontWeight: 700 }}>{te.name[0]}</div>
          <div>
            <h2 style={{ color: h.tx, fontSize: 18, fontWeight: 700, margin: 0 }}>{te.name}</h2>
            <div style={{ color: h.sc, fontSize: 12 }}>{t.payHistory}</div>
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => window.print()} style={{ padding: "6px 10px", borderRadius: 8, border: `1px solid ${h.bd}`, background: "transparent", color: h.sc, cursor: "pointer", fontSize: 12 }}>🖨️ Print</button>
          <button onClick={handleDownload} style={{ padding: "6px 10px", borderRadius: 8, border: `1px solid ${h.ac}`, background: `${h.ac}15`, color: h.ac, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"📥 " + t.download}</button>
        </div>
      </div>

      {tp.length === 0 && <div style={{ ...crd(h), textAlign: "center", padding: 30, color: h.sc }}>{t.noPayRecords}</div>}

      {tp.map(p => <div key={p.id} style={crd(h)}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div><div style={{ color: h.tx, fontSize: 14, fontWeight: 600 }}>{p.mo}</div><div style={{ color: h.sc, fontSize: 11 }}>{p.dt || "—"} · {p.mth || "—"}</div></div>
          <div style={{ textAlign: "right" }}><div style={{ color: h.tx, fontWeight: 700, fontSize: 15 }}>₹{(p.amt + (p.com || 0)).toLocaleString()}</div>
            <span style={bdg(p.st === "paid" ? `${h.gn}20` : p.pending ? `${h.wn}20` : `${h.rd}20`, p.st === "paid" ? h.gn : p.pending ? h.wn : h.rd)}>{p.st === "paid" ? "✓ " + t.paid : p.pending ? "⏳ " + t.pending : t.due}</span></div></div>
        {p.com > 0 && <div style={{ color: h.sc, fontSize: 11, marginTop: 6 }}>{t.rentAmt} ₹{p.amt.toLocaleString()} + {t.commonAmt} ₹{p.com}</div>}

        <div className="no-print" style={{ display: "flex", gap: 8, marginTop: 10 }}>
          {p.st === "paid" && <button onClick={() => setReceiptPay(p)} style={{ flex: 2, padding: 8, borderRadius: 8, border: `1px solid ${h.ac}`, background: `${h.ac}08`, color: h.ac, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"🧾 " + (t.viewReceipt || "Receipt")}</button>}
          <button onClick={() => deleteHstPay(p.id)} style={{ flex: 1, padding: 8, borderRadius: 8, border: "none", background: `${h.rd}15`, color: h.rd, cursor: "pointer", fontSize: 12, fontWeight: 600 }}>{"✕ " + t.delete}</button>
        </div>

        {p.txns && p.txns.length > 0 && <TxnHistory txns={p.txns} payment={p} />}
      </div>)}
    </div>

    {/* PRINT ONLY DOCUMENT VIEW */}
    <div className="print-only">
      <h1 style={{ textAlign: "center", borderBottom: "2px solid #000", paddingBottom: "10px" }}>Rajieev House Rental</h1>
      <h2 style={{ textAlign: "center", marginTop: "10px" }}>Payment History Report</h2>

      <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", marginBottom: "20px" }}>
        <div>
          <p><strong>Tenant Name:</strong> {te.name}</p>
          <p><strong>Phone:</strong> {te.ph}</p>
        </div>
        <div style={{ textAlign: "right" }}>
          <p><strong>Date Generated:</strong> {new Date().toLocaleDateString()}</p>
        </div>
      </div>

      <table className="print-table">
        <thead>
          <tr>
            <th>Month</th>
            <th>Type</th>
            <th>Status</th>
            <th>Recorded Date</th>
            <th>Method</th>
            <th style={{ textAlign: "right" }}>Total</th>
          </tr>
        </thead>
        <tbody>
          {tp.length === 0 ? (
            <tr><td colSpan="6" style={{ textAlign: "center", padding: "20px" }}>No payments recorded yet.</td></tr>
          ) : (
            tp.map((p, i) => {
              const rowTotal = p.amt + (p.com || 0);
              return (
                <React.Fragment key={p.id || i}>
                  <tr>
                    <td><strong>{p.mo}</strong></td>
                    <td>Rent + CC</td>
                    <td>{p.st.toUpperCase()}</td>
                    <td>{p.dt || "—"}</td>
                    <td>{(p.mth || "—").toUpperCase()}</td>
                    <td style={{ textAlign: "right" }}><strong>₹{rowTotal.toLocaleString()}</strong></td>
                  </tr>
                  {p.txns && p.txns.length > 0 && p.txns.map((tx, j) => (
                    <tr key={`${p.id}-tx-${j}`} className="sub-row">
                      <td style={{ paddingLeft: "30px" }}>↳ Transact.</td>
                      <td>{tx.type === "full" ? "Full" : "Partial"}</td>
                      <td>{tx.status.toUpperCase()}</td>
                      <td>{tx.dt}</td>
                      <td>{(tx.mth || "—").toUpperCase()}</td>
                      <td style={{ textAlign: "right" }}>₹{tx.amt.toLocaleString()}</td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>

      <p style={{ marginTop: "40px", textAlign: "center", fontStyle: "italic", fontSize: "10pt" }}>End of Report</p>
    </div>
  </div>;
}

export default TenantPayHistoryPage;
